$(document).ready(function(){

	var cookiesVal = Cookies.get('cookies');

	if (cookiesVal === undefined || cookiesVal === 'undefined') {
		setTimeout(function(){
			showCookies();
		},1500);
	} else {
		hideCookies();
	}


	$('.actionClose').on('click', function(){
		hideCookies();
	});

	$('.btn__decline').on('click', function(){
		Cookies.set('cookies','decline',{expires: 30});
	});

	$('.btn__allow').on('click', function(){
		Cookies.set('cookies','allow',{expires: 30});
	});


	function showCookies(){
		$('.cookies__wrapper').removeClass('hide').addClass('show');
	}

	function hideCookies(){
		$('.cookies__wrapper').removeClass('show').addClass('hide');
	}
	
});